import { createStyle } from "~/common/utils/create-style";

const avatarStyle = createStyle({
  slots: {
    container: [
      "relative overflow-hidden rounded-[5px] flex items-center justify-center",
      "text-black",
    ],
  },
  variants: {
    size: {
      small: { container: "size-20" },
      large: { container: "size-64" },
    },
  },
  defaultVariants: {
    size: "small",
  },
})();

export { avatarStyle };
